import React from "react";
import styled from "styled-components";

const Container = styled.nav`
  position: fixed;
  right: 0;
  text-align: right;
  ul {
    color: #c0c0c0;
    list-style-type: none;
    margin: 1em;
    padding: 0;
    a {
      color: #a0a0a0;
      transition: color .5s;
      &:hover {
        color: ${({ darkMode }) => darkMode ? 'white' : 'black'};
      }
    }
  }
`;

export const Nav = ({ darkMode }) => {
  return (
    <Container darkMode={darkMode}>
      <ul>
        <li>SSS</li>
        <li>
          <a href="https://goodenoughfor.me" target="_blank">
            Good Enough
          </a>
        </li>
        <li>~</li>
        <li>
          <a href="mailto:steffenssornpao@gmail.com">
            Contact
          </a>
        </li>
      </ul>
    </Container>
  );
};
